import {styled} from '@ngw6/us-components';

export const ModalDisplayContainer = styled.div`
  position: fixed;
  z-index: 999;
`;
